import { gql, TypedDocumentNode } from '@apollo/client'
import type { WorkPostSheetItemFragment } from './__generated__/WorkPostSheetItemFragment'

export const workPostSheetItemFragment: TypedDocumentNode<WorkPostSheetItemFragment> = gql`
  fragment WorkPostSheetItemFragment on WorkPostSheetItem {
    comment
    id
    name
  }
`
